import type { FieldProps } from '@seek/forms-ui/lib/Field/Field';
import { useTranslations } from '@vocab/react';
import { Stack, Text, TextField } from 'braid-design-system';

import appTranslations from 'src/App/App.vocab';
import translations from 'src/App/Components/UserFormProvider/.vocab';
import type { HirerUserEmailFoundPayloadV2 } from 'src/graphql/generated';

import type { UserFormValues } from '../userFormFields';

interface FormUserDetailsProps {
  email: string;
  firstName: FieldProps<UserFormValues, 'firstName', any, any>;
  lastName: FieldProps<UserFormValues, 'lastName', any, any>;
  user?: HirerUserEmailFoundPayloadV2;
}

export const FormUserDetails = ({
  email,
  firstName,
  lastName,
  user,
}: FormUserDetailsProps) => {
  const { t } = useTranslations(translations);
  const { t: appTrans } = useTranslations(appTranslations);

  return (
    <Stack space="large">
      <Stack space="small">
        <Text weight="strong">{appTrans('Email')}</Text>
        <Text data={{ 'dd-privacy': 'mask', 'hj-masked': true }}>{email}</Text>
      </Stack>
      {!user && (
        <Stack space="small">
          <TextField
            id="firstName"
            label={t('Given name')}
            aria-label="firstName"
            value={firstName.value}
            message={firstName.errorMessage}
            tone={firstName.errorMessage ? 'critical' : undefined}
            reserveMessageSpace
            onChange={firstName.onChange}
            onBlur={lastName.onBlur}
          />
          <TextField
            id="lastName"
            label={t('Family name')}
            aria-label="lastName"
            value={lastName.value}
            message={lastName.errorMessage}
            tone={lastName.errorMessage ? 'critical' : undefined}
            reserveMessageSpace
            onChange={lastName.onChange}
            onBlur={lastName.onBlur}
          />
        </Stack>
      )}
    </Stack>
  );
};
